// Tracked is scan status 2 (In Use) and 3 (Left Onsite); Not Tracked is the
// complement, which the items page expresses as the remaining statuses rather
// than as a negation.
export const TRACKED_STATUSES = '2,3';
export const NOT_TRACKED_STATUSES = '0,1,-1,5';

// A link into the item list carrying whichever of the dashboard's dimensions
// the caller is drilling into. Category is by name, since uncategorised
// products report as "Other" and have no id.
export const itemsLink = ({
  category,
  manufacturerId,
  productId,
  scanStatus,
}: {
  category?: string;
  manufacturerId?: string;
  productId?: string;
  scanStatus?: string;
}): string => {
  const search = new URLSearchParams({ active: 'true' });
  if (category && category !== 'Total') {
    search.set('productCategory', category);
  }
  if (manufacturerId) {
    search.set('manufacturerId', manufacturerId);
  }
  if (productId) {
    search.set('productId', productId);
  }
  if (scanStatus) {
    search.set('scanStatus', scanStatus);
  }
  return `/tools/items?${search.toString()}`;
};
